import axios from '@axios'

export default {
    namespaced: true,
    state: {
        maquinas: [],
        reporte: [],
        equipos_tuneles: [],
        datosExcel: [],
        divisiones: [],
        subbodegas: [],
        bodegas: [],
        colores: [],
        movimientos: [],
        movimientosAnular: [],
        etiquetasAnuladas: [],
        lote: {},
        loteGraph: {},
        registroFechas: [],
        libras: [],
        librasXBodega: [],
        librasXProceso: [],
        etiquetasXLote: [],
        etiquetasXArea: [],
        color: [],
        tipolote: [],
        establecimiento: [],
        establecimientoPantalla:[],
        fabricasPantalla:[],
        establecimientoE: [],
        establecimientos: [],
        establecimientosOrigen: [],
        establecimientosDestino: [],
        fabricas: [],
        fabricasE: [],
        fabrica: [],
        fabricasxDivision: [],
        area: [],
        areaHielo: [],
        areaDesca: [],
        areas: [],
        areasE: [],
        procesos: [],
        procesosE: [],
        equipos: [],
        equiposE: [],
        tallas: [],
        lote: [],
        tipoetq: [],
        camaronera: [],
        controlproceso: [],
        controlprocesodetalle: [],
        controlprocesodetallecolor: [],
        productoteminado: [],
        informarcionLinea: [],
        seguimientocontrolproceso: [],
        nucanastas: [],
        lotecamaronera: [],
        procesolinea: [],
        procesolineacanasta: [],
        movBines: [],
        rendimiento: [],
        tiempoEspera: [],
        tiempoPlantaRecepcion: [],
        descabezado: [],
        clasificacion: [],
        datosCabiplant: [],
        plantasA20702: [],
        codigoscalidad: [],
        itemCamaron: [],
        itemReceta: [],
        numOrden: {},
        infoOrden: {},
        librasReclasificadas: [],
        librasCocido: [],
        VAGavetas: [],
        permisosOrdenPedidoDivision: [],
        permisosOrdenPedidoAreas: [],
        ordenes: [],
        descargarDocumentoOP: [],
        lineasCamaron: [],
        downloadFT: [],
        opcionesProduccionAbierta: {},
        descargarFichaTecnica: {},
        descargarEspecificacionesDocx: {},
        categoria: [],
        // Liquidacion
        tipos_embarque: [],
        facturaXEmbarqueTipo: {},
        embarque_items: [],
        itemsXop: [],
        tipos_producto: [],
        tipos_certificados_producto: [],
        liq_embarque: {},
        hh_embarque: [],
        info_embarque: {},
        reporteP_T: [],
        plantaxUserPant: [],
        // Liquidacion
        // Mantenimiento: ItemCamaron
        secuencia: {},
        // Mantenimiento: ItemCamaron
        // TipoCongelacion
        allTipoCongelacion: [],
        tipoCongelacion: [],
        // TipoCongelacion
        // Linea
        allLinea: [],
        linea: [],
        // Linea
        // Nandina
        allNandina: [],
        nandina: [],
        nandinaByParams: [],
        // Nandina

        // Especie
        allEspecie: [],
        especie: [],
        // Especie

        // Marca
        allMarca: [],
        marca: [],
        // Marca

        // ProcesoVA
        allProcesoVA: [],
        proceso_va: [],
        // ProcesoVA

        // Sublinea
        allSublinea: [],
        sublinea: [],
        sublineaxlinea: [],
        // Sublinea

        // Talla
        allTalla: [],
        talla: [],
        // Talla

        // TipoProducto
        allTipoProducto: [],
        tipoProducto: [],
        tipoProductoByParams: [],
        // TipoProducto

        // Tratamiento
        allTratamiento: [],
        tratamiento: [],
        // Tratamiento

        // Unidad
        allUnidad: [],
        unidad: [],
        // Unidad

        // Certificacion
        allCertificacion: [],
        certificacion: [],
        // Certificacion

        // Calidad
        allCalidad: [],
        calidad: [],
        // Calidad

        // EstadoProducto
        allEstadoProducto: [],
        estadoProducto: [],
        // EstadoProducto

        // MateriaPrima
        allMateriaPrima: [],
        materiaPrima: [],
        // MateriaPrima

        // Presentacion
        allPresentacion: [],
        presentacion: [],
        // Presentacion

        // TipoEmpaque
        allTipoEmpaque: [],
        tipoEmpaque: [],
        // TipoEmpaque

        // ItemPT
        allItemPT: [],
        itemsPT: [],
        // ItemPT

        // UnidadMedida
        allUnidadMedida: [],
        unidadMedida: [],
        // UnidadMedida
        // Conteo PT
        allConteoPT: [],
        // Conteo PT
    },
    getters: {
        getCategoria(state) {
            return state.categoria
        },
        getReporteRotacion(state) {
            return state.reporte
        },
        getDatosExcel(state) {
            return state.datosExcel
        },
        getDatosCabiplant(state) {
            return state.datosCabiplant
        },
        getDivisiones(state) {
            return state.divisiones
        },
        getSubbodegas(state) {
            return state.subbodegas
        },
        getBodegasInternas(state) {
            return state.bodegas
        },
        getObtenerColores(state) {
            return state.colores
        },
        getObtenerDatosTabla(state) {
            return state.datosTabla
        },
        getMovimientos(state) {
            return state.movimientos
        },
        getRendimiento(state) {
            return state.rendimiento
        },
        getLibrasReclasificadas(state) {
            return state.librasReclasificadas
        },
        getLibrasCocido(state) {
            return state.librasCocido
        },
        getDescabezado(state) {
            return state.descabezado
        },
        getClasificacion(state) {
            return state.clasificacion
        },
        getMovimientosAnular(state) {
            return state.movimientosAnular
        },
        getEtiquetasAnuladas(state) {
            return state.etiquetasAnuladas
        },
        getLoteGraph(state) {
            return state.loteGraph
        },
        getRegistroFechas(state) {
            return state.getRegistroFechas
        },
        getInfoLibras(state) {
            return state.libras
        },
        getInfoLibrasXProceso(state) {
            return state.librasXProceso
        },
        getInfoLibrasXBodega(state) {
            return state.librasXBodega
        },
        getEtiquetasXLote(state) {
            return state.etiquetasXLote
        },
        getEtiquetasXArea(state) {
            return state.etiquetasXArea
        },
        getColores(state) {
            return state.color
        },
        getTipoLote(state) {
            return state.tipolote
        },
        getTipoEtqs(state) {
            return state.tipoetq
        },
        getEstablecimiento(state) {
            return state.establecimiento
        },
        getEstablecimientoPantalla(state) {
            return state.establecimientoPantalla;
        },
        getFabricasPantalla(state) {
            return state.fabricasPantalla;
        },
        getEstablecimientoE(state) {
            return state.establecimientoE
        },
        getEstablecimientos(state) {
            return state.establecimientos
        },
        getEstablecimientosDestino(state) {
            return state.establecimientosDestino
        },
        getEstablecimientosOrigen(state) {
            return state.establecimientosOrigen
        },
        getMaquinas(state) {
            return state.maquinas
        },
        getEquiposTuneles(state) {
            return state.equipos_tuneles
        },
        getFabricas(state) {
            return state.fabricas
        },
        getFabricasxDivision(state) {
            return state.fabricasxDivision
        },
        getFabricasE(state) {
            return state.fabricasE
        },
        getFabrica(state) {
            return state.fabrica
        },
        getArea(state) {
            return state.area
        },
        getAreaHielo(state) {
            return state.areaHielo
        },
        getAreaDescabezado(state) {
            return state.areaDesca
        },
        getAreas(state) {
            return state.areas
        },
        getAreasE(state) {
            return state.areasE
        },
        getProcesos(state) {
            return state.procesos
        },
        getProcesosE(state) {
            return state.procesosE
        },
        getEquipos(state) {
            return state.equipos
        },
        getEquiposE(state) {
            return state.equiposE
        },
        getTallas(state) {
            return state.tallas
        },
        getLote(state) {
            return state.lote
        },
        getCamaronera(state) {
            return state.camaronera
        },
        getControlProceso(state) {
            return state.controlproceso
        },
        getControlProcesoDetalle(state) {
            return state.controlprocesodetalle
        },
        getControlProcesoDetalleColor(state) {
            return state.controlprocesodetallecolor
        },
        getProductoterminado(state) {
            return state.productoterminado
        },
        getInformacionLinea(state) {
            return state.informarcionLinea
        },
        getSeguimientoControlProceso(state) {
            return state.seguimientocontrolproceso
        },
        getnucanastas(state) {
            return state.nucanastas
        },
        getprocesolinea(state) {
            return state.procesolinea
        },
        getprocesolineacanasta(state) {
            return state.procesolineacanasta
        },
        getlotecamaronera(state) {
            return state.lotecamaronera
        },
        getMovimientoBines(state) {
            return state.movBines
        },
        getPlantasA20702(state) {
            return state.plantasA20702
        },
        getCodigosCalidad(state) {
            return state.codigoscalidad
        },
        getItemCamaronByCoMateria(state) {
            return state.itemCamaron
        },
        getItemRecetaByCoItem(state) {
            return state.itemReceta
        },
        getNumOrden(state) {
            return state.numOrden
        },
        getInfoOrden(state) {
            return state.infoOrden
        },
        getPermisosOrdenPedidoDivision(state) {
            return state.permisosOrdenPedidoDivision
        },
        getPermisosOrdenPedidoArea(state) {
            return state.permisosOrdenPedidoAreas
        },
        getOrdenes(state) {
            return state.ordenes
        },
        getLineasCamaron(state) {
            return state.lineasCamaron
        },
        getOpcionesProduccionAbierta(state) {
            return state.opcionesProduccionAbierta
        },
        getDescargarFichaTecnica(state) {
            return state.descargarFichaTecnica
        },
        getDescargarEspecificacionesDocx(state) {
            return state.descargarEspecificacionesDocx
        },
        // Liquidacion
        getTiposEmbarque(state) {
            return state.tipos_embarque
        },
        getFacturaXembarqueTipo(state) {
            return state.facturaXEmbarqueTipo
        },
        getEmbarqueItems(state) {
            return state.embarque_items
        },
        getItemsXOrdProd(state) {
            return state.itemsXop
        },
        getTiposProducto(state) {
            return state.tipos_producto
        },
        getTiposCertificadosXProducto(state) {
            return state.tipos_certificados_producto
        },
        getLiqEmbarque(state) {
            return state.liq_embarque
        },
        getHHEmbarque(state) {
            return state.hh_embarque
        },
        getInfoEmbarque(state) {
            return state.info_embarque
        },
        getPermisosUsuarioReporte(state) {
            return state.reporteP_T
        },
        getPlantaxUserPantalla(state) {
            return state.plantaxUserPant
        },
        // Liquidacion
        // Mantenimiento: ItemCamaron
        getSecuenciaItemCamaron(state) {
            return state.secuencia
        },
        // Mantenimiento: ItemCamaron
        // TipoCongelacion
        getTipoCongelacion(state) {
            return state.tipoCongelacion
        },
        getAllTipoCongelacion(state) {
            return state.allTipoCongelacion
        },
        // TipoCongelacion
        // Linea
        getLinea(state) {
            return state.linea
        },
        getAllLinea(state) {
            return state.allLinea
        },
        // Linea
        // Nandina
        getNandina(state) {
            return state.nandina
        },
        getNandinaByParams(state) {
            return state.nandinaByParams
        },
        getAllNandina(state) {
            return state.allNandina
        },
        // Nandina
        // Especie
        getEspecie(state) {
            return state.especie
        },
        getAllEspecie(state) {
            return state.allEspecie
        },
        // Marca
        getMarca(state) {
            return state.marca
        },
        getAllMarca(state) {
            return state.allMarca
        },
        // Marca
        // ProcesoVA
        getProcesoVA(state) {
            return state.proceso_va
        },
        getAllProcesoVA(state) {
            return state.allProcesoVA
        },
        // ProcesoVA
        // Sublinea
        getSublinea(state) {
            return state.sublinea
        },
        getAllSublinea(state) {
            return state.allSublinea
        },
        getSublineaXLinea(state) {
            return state.sublineaxlinea
        },
        // Sublinea
        // Talla
        getTalla(state) {
            return state.talla
        },
        getAllTalla(state) {
            return state.allTalla
        },
        // Talla
        // TipoProducto
        getTipoProducto(state) {
            return state.tipoProducto
        },
        getAllTipoProducto(state) {
            return state.allTipoProducto
        },
        getTipoProductoByParams(state) {
            return state.tipoProductoByParams
        },
        // TipoProducto
        // Tratamiento
        getTratamiento(state) {
            return state.tratamiento
        },
        getAllTratamiento(state) {
            return state.allTratamiento
        },
        // Tratamiento
        // Unidad
        getUnidad(state) {
            return state.unidad
        },
        getAllUnidad(state) {
            return state.allUnidad
        },
        // Unidad
        // Certificacion
        getCertificacion(state) {
            return state.certificacion
        },
        getAllCertificacion(state) {
            return state.allCertificacion
        },
        // Certificacion
        // Calidad
        getCalidad(state) {
            return state.calidad
        },
        getAllCalidad(state) {
            return state.allCalidad
        },
        // Calidad
        // EstadoProducto
        getEstadoProducto(state) {
            return state.estadoProducto
        },
        getAllEstadoProducto(state) {
            return state.allEstadoProducto
        },
        // EstadoProducto
        // MateriaPrima
        getMateriaPrima(state) {
            return state.materiaPrima
        },
        getAllMateriaPrima(state) {
            return state.allMateriaPrima
        },
        // MateriaPrima
        // Presentacion
        getPresentacion(state) {
            return state.presentacion
        },
        getAllPresentacion(state) {
            return state.allPresentacion
        },
        // Presentacion
        // TipoEmpaque
        getTipoEmpaque(state) {
            return state.tipoEmpaque
        },
        getAllTipoEmpaque(state) {
            return state.allTipoEmpaque
        },
        // TipoEmpaque
        // ItemPT
        getItemPT(state) {
            return state.itemsPT
        },
        getAllItemPT(state) {
            return state.allItemPT
        },
        // ItemPT
        // UnidadMedida
        getUnidadMedida(state) {
            return state.unidadMedida;
        },
        getAllUnidadMedida(state) {
            return state.allUnidadMedida;
        },
        // UnidadMedida
        // Conteo PT
        getConteoPT(state) {
            return state.allConteoPT
        },
        // Conteo PT
    },
    mutations: {
        setDatosCabiplant(state, datosCabiplant) {
            state.datosCabiplant = datosCabiplant
        },
        setReporteRotacion(state, reporte) {
            state.reporte = reporte
        },
        setDatosExcel(state, datosExcel) {
            state.datosExcel = datosExcel
        },
        setDivisiones(state, divisiones) {
            state.divisiones = divisiones
        },
        setSubbodegas(state, subbodegas) {
            state.subbodegas = subbodegas
        },
        setBodegasInternas(state, bodegas) {
            state.bodegas = bodegas
        },
        setObtenerColores(state, colores) {
            state.colores = colores
        },
        setObtenerDatosTabla(state, datosTabla) {
            state.datosTabla = datosTabla
        },
        setMovimientos(state, movimientos) {
            state.movimientos = movimientos
        },
        setMovimientosAnular(state, movimientosAnular) {
            state.movimientos = movimientosAnular
        },
        setEtiquetasAnuladas(state, etiquetasAnuladas) {
            state.etiquetasAnuladas = etiquetasAnuladas
        },
        setLoteGraph(state, loteGraph) {
            state.loteGraph = loteGraph
        },
        setInfoLibras(state, libras) {
            state.libras = libras
        },
        setInfoLibrasXProceso(state, librasXProceso) {
            state.librasXProceso = librasXProceso
        },
        setInfoLibrasXBodega(state, librasXBodega) {
            state.librasXBodega = librasXBodega
        },
        setEtiquetasXLote(state, etiquetasXLote) {
            state.etiquetasXLote = etiquetasXLote
        },
        setEtiquetasXArea(state, etiquetasXArea) {
            state.etiquetasXArea = etiquetasXArea
        },
        setRendimiento(state, rendimiento) {
            state.rendimiento = rendimiento
        },
        setLibrasClasificadas(state, librasReclasificadas) {
            state.librasReclasificadas = librasReclasificadas
        },
        setLibrasCocido(state, librasCocido) {
            state.librasCocido = librasCocido
        },
        setVAGavetas(state, VAGavetas) {
            state.VAGavetas = VAGavetas
        },
        setDescabezado(state, descabezado) {
            state.descabezado = descabezado
        },
        setClasificacion(state, clasificacion) {
            state.clasificacion = clasificacion
        },
        setTipoReporteP_T(state, reporteP_T) {
            state.reporteP_T = reporteP_T
        },
        setPlantaxUserPantalla(state, plantaxUserPant) {
            state.plantaxUserPant = plantaxUserPant
        },

        setNextLoteClasificacion(state, datos) {
            const c = state.clasificacion.find(c => c.co_equipo_origen === datos.maquina)
            if (c) {
                c.nextLote = datos.nextLote
            } else {
                c.nextLote = datos.nextLote
            }
        },
        setLbsTag(state, datos) {
            datos.json.forEach(e => {
                const c = state.clasificacion.find(c => c.co_equipo_origen === parseInt(e.maquina))
                if (c.lbsTag) {
                    c.lbsTag = parseFloat(c.lbsTag) + e.lbsTag
                } else {
                    c.lbsTag = e.lbsTag
                }
                if (c.numCanastillas) {
                    c.numCanastillas = parseFloat(c.numCanastillas) + 1
                } else {
                    c.numCanastillas = 1
                }
                const cd = c.detalle.find(cd => cd.co_control_proceso_detalle === parseInt(e.co_control_proceso_detalle))
                const cl = cd.colores.find(
                    cl => cl.co_control_proceso_detalle_color === parseInt(e.co_control_proceso_detalle_color)
                )
                if (cl.lbsTagColor) {
                    cl.lbsTagColor = parseFloat(cl.lbsTagColor) + e.lbsTag
                } else {
                    cl.lbsTagColor = e.lbsTag
                }
                if (cl.numTagColor) {
                    cl.numTagColor = parseInt(cl.numTagColor) + 1
                } else {
                    cl.numTagColor = 1
                }
            })
        },
        setColores(state, color) {
            state.color = color
        },
        setTipoLote(state, tipolote) {
            state.tipolote = tipolote
        },
        setTipoEtiquetas(state, tipoetq) {
            state.tipoetq = tipoetq
        },
        setEstablecimiento(state, establecimiento) {
            state.establecimiento = establecimiento
        },
        setEstablecimientoPantalla(state, establecimientoPantalla) {
            state.establecimientoPantalla = establecimientoPantalla
        },
        setFabricasPantalla(state, fabricasPantalla) {
            state.fabricasPantalla = fabricasPantalla
        },
        setEstablecimientoE(state, establecimientoE) {
            state.establecimientoE = establecimientoE
        },
        setEstablecimientos(state, establecimientos) {
            state.establecimientos = establecimientos
        },
        setEstablecimientosOrigen(state, establecimientosOrigen) {
            state.establecimientosOrigen = establecimientosOrigen
        },
        setEstablecimientosDestino(state, establecimientosDestino) {
            state.establecimientosDestino = establecimientosDestino
        },
        setFabricas(state, fabricas) {
            state.fabricas = fabricas
        },
        setFabricasxDivision(state, fabricasxDivision) {
            state.fabricasxDivision = fabricasxDivision
        },
        setFabricasE(state, fabricasE) {
            state.fabricasE = fabricasE
        },
        setFabrica(state, fabricas) {
            state.fabrica = fabricas
        },
        setMaquinas(state, maquinas) {
            state.maquinas = maquinas
        },
        setEquiposTuneles(state, equipos_tuneles) {
            state.equipos_tuneles = equipos_tuneles
        },
        setArea(state, area) {
            state.area = area
            state.area.push({
                descripcion: 'TODAS',
                co_area: 0,
                estado_mov: 2,
            })
        },
        setAreaHielo(state, areaHielo) {
            state.areaHielo = areaHielo
            state.areaHielo.push({
                descripcion: 'TODAS',
                co_bodega_hielo: 0,
            })
        },
        setAreaDescabezado(state, area) {
            state.areaDesca = area
        },
        setAreas(state, areas) {
            state.areas = areas
        },
        setAreasE(state, areasE) {
            state.areasE = areasE
        },
        setProcesos(state, procesos) {
            state.procesos = procesos
        },
        setProcesosE(state, procesosE) {
            state.procesosE = procesosE
        },
        setEquipos(state, equipos) {
            state.equipos = equipos
        },
        setEquiposE(state, equiposE) {
            state.equiposE = equiposE
        },
        setTallas(state, tallas) {
            state.tallas = tallas
        },
        setLote(state, lote) {
            state.lote = lote
        },
        setCamaronera(state, camaronera) {
            state.camaronera = camaronera
        },
        setControlProceso(state, controlproceso) {
            state.controlproceso = controlproceso
        },
        setControlProcesoDetalle(state, controlprocesodetalle) {
            state.controlprocesodetalle = controlprocesodetalle
        },
        setControlProcesoDetalleColor(state, controlprocesodetallecolor) {
            state.controlprocesodetallecolor = controlprocesodetallecolor
        },
        setProductoTerminado(state, productoterminado) {
            state.productoterminado = productoterminado
        },
        setRangoFechas(state, rangofechas) {
            state.rangofechas = rangofechas
        },
        setinformacionLinea(state, informarcionLinea) {
            state.informarcionLinea = informarcionLinea
        },
        setSeguimientoControlProceso(state, seguimientocontrolproceso) {
            state.seguimientocontrolproceso = seguimientocontrolproceso
        },
        setnucanastas(state, nucanastas) {
            state.nucanastas = nucanastas
        },
        setprocesolinea(state, procesolinea) {
            state.procesolinea = procesolinea
        },
        setprocesolineacanasta(state, procesolineacanasta) {
            state.procesolineacanasta = procesolineacanasta
        },
        setlotecamaronera(state, lotecamaronera) {
            state.lotecamaronera = lotecamaronera
        },
        setMovBines(state, movBines) {
            state.movBines = movBines
        },
        setPlantasA20702(state, plantasA20702) {
            state.plantasA20702 = plantasA20702
        },
        setCodigosCalidad(state, codigoscalidad) {
            state.codigoscalidad = codigoscalidad
        },
        setItemCamaronByCoMateria(state, itemCamaron) {
            state.itemCamaron = itemCamaron
        },
        setItemRecetaByCoItem(state, itemReceta) {
            state.itemReceta = itemReceta
        },
        setNumOrden(state) {
            return state.numOrden
        },
        setInfoOrden(state, infoOrden) {
            state.infoOrden = infoOrden
        },

        setPermisosOrdenPedidoDivision(state, permisosOrdenPedidoDivision) {
            state.permisosOrdenPedidoDivision = permisosOrdenPedidoDivision
        },
        setPermisosOrdenPedidoArea(state, permisosOrdenPedidoAreas) {
            state.permisosOrdenPedidoAreas = permisosOrdenPedidoAreas
        },
        setOrdenes(state, orden) {
            state.orden = orden
        },
        setDescargarDocumentoOP(state, descargarDocumentoOP) {
            state.descargarDocumentoOP = descargarDocumentoOP
        },
        setLineasCamaron(state, lineasCamaron) {
            state.lineasCamaron = lineasCamaron
        },
        setDownloadFT(state, downloadFT) {
            state.downloadFT = downloadFT
        },
        setOpciones(state, opcionesProduccionAbierta) {
            state.opcionesProduccionAbierta = opcionesProduccionAbierta
        },
        setDescargarFichaTecnica(state, descargarFichaTecnica) {
            state.descargarFichaTecnica = descargarFichaTecnica
        },
        setDescargarEspecificacionesDocx(state, descargarEspecificacionesDocx) {
            state.descargarEspecificacionesDocx = descargarEspecificacionesDocx
        },
        // Liquidacion
        setTiposEmbarque(state, TiposEmbarque) {
            state.tipos_embarque = TiposEmbarque
        },
        setFacturaXEmbarqueTipo(state, facturaXEmbarqueTipo) {
            state.facturaXEmbarqueTipo = facturaXEmbarqueTipo
        },
        setEmbarqueItems(state, embarque_items) {
            state.embarque_items = embarque_items
        },
        setItemsXOrdProd(state, itemsXop) {
            state.itemsXop = itemsXop
        },
        setTiposProducto(state, TiposProducto) {
            state.tipos_producto = TiposProducto
        },
        setTiposCertificadosXProducto(state, TiposCertificadosXProducto) {
            state.tipos_certificados_producto = TiposCertificadosXProducto
        },
        setLiqEmbarque(state, LiqEmbarque) {
            state.liq_embarque = LiqEmbarque
        },
        setHHEmbarque(state, HHEmbarque) {
            state.hh_embarque = HHEmbarque
        },
        setInfoEmbarque(state, infoEmbarque) {
            state.info_embarque = infoEmbarque
        },
        setTiempoEspera(state, tiempoEspera) {
            state.tiempoEspera = tiempoEspera
        },
        setTiempoPlantaRecepcion(state, tiempoPlantaRecepcion) {
            state.tiempoPlantaRecepcion = tiempoPlantaRecepcion
        },
        // Liquidacion
        // Mantenimiento: ItemCamaron
        setSecuenciaItemCamaron(state, secuencia) {
            state.secuencia = secuencia
        },
        // Mantenimiento: ItemCamaron
        // TipoCongelacion
        setAllTipoCongelacion(state, allTipoCongelacion) {
            state.allTipoCongelacion = allTipoCongelacion
        },
        setTipoCongelacion(state, tipoCongelacion) {
            state.tipoCongelacion = tipoCongelacion
        },
        // TipoCongelacion
        // Linea
        setAllLinea(state, allLinea) {
            state.allLinea = allLinea
        },
        setLinea(state, linea) {
            state.linea = linea
        },
        // Linea
        // Nandina
        setAllNandina(state, allNandina) {
            state.allNandina = allNandina
        },
        setNandina(state, nandina) {
            state.nandina = nandina
        },
        setNandinaByParams(state, nandinaByParams) {
            state.nandinaByParams = nandinaByParams
        },
        // Nandina

        setCategoria(state, categoria) {
            state.categoria = categoria
        },

        // Especie
        setAllEspecie(state, allEspecie) {
            state.allEspecie = allEspecie
        },
        setEspecie(state, especie) {
            state.especie = especie
        },
        // Especie
        // Marca
        setAllMarca(state, allMarca) {
            state.allMarca = allMarca
        },
        setMarca(state, marca) {
            state.marca = marca
        },
        // Marca
        // ProcesoVA
        setAllProcesoVA(state, allProcesoVA) {
            state.allProcesoVA = allProcesoVA
        },
        setProcesoVA(state, proceso_va) {
            state.proceso_va = proceso_va
        },
        // ProcesoVA
        // Sublinea
        setAllSublinea(state, allSublinea) {
            state.allSublinea = allSublinea
        },
        setSublinea(state, sublinea) {
            state.sublinea = sublinea
        },
        setSublineaXLinea(state, sublineaxlinea) {
            state.sublineaxlinea = sublineaxlinea
        },
        // Sublinea
        // Talla
        setAllTalla(state, allTalla) {
            state.allTalla = allTalla
        },
        setTalla(state, talla) {
            state.talla = talla
        },
        // Talla
        // TipoProducto
        setAllTipoProducto(state, allTipoProducto) {
            state.allTipoProducto = allTipoProducto
        },
        setTipoProducto(state, tipoProducto) {
            state.tipoProducto = tipoProducto
        },
        // TipoProducto
        // Tratamiento
        setAllTratamiento(state, allTratamiento) {
            state.allTratamiento = allTratamiento
        },
        setTratamiento(state, tratamiento) {
            state.tratamiento = tratamiento
        },
        setTipoProductoByParams(state, tipoProductoByParams) {
            state.tipoProductoByParams = tipoProductoByParams
        },
        // Tratamiento
        // Unidad
        setAllUnidad(state, allUnidad) {
            state.allUnidad = allUnidad
        },
        setUnidad(state, unidad) {
            state.unidad = unidad
        },
        // Unidad
        // Certificacion
        setAllCertificacion(state, allCertificacion) {
            state.allCertificacion = allCertificacion
        },
        setCertificacion(state, certificacion) {
            state.certificacion = certificacion
        },
        // Certificacion
        // Calidad
        setAllCalidad(state, allCalidad) {
            state.allCalidad = allCalidad
        },
        setCalidad(state, calidad) {
            state.calidad = calidad
        },
        // Calidad
        // EstadoProducto
        setAllEstadoProducto(state, allEstadoProducto) {
            state.allEstadoProducto = allEstadoProducto
        },
        setEstadoProducto(state, estadoProducto) {
            state.estadoProducto = estadoProducto
        },
        // EstadoProducto
        // MateriaPrima
        setAllMateriaPrima(state, allMateriaPrima) {
            state.allMateriaPrima = allMateriaPrima
        },
        setMateriaPrima(state, materiaPrima) {
            state.materiaPrima = materiaPrima
        },
        // MateriaPrima
        // Presentacion
        setAllPresentacion(state, allPresentacion) {
            state.allPresentacion = allPresentacion
        },
        setPresentacion(state, presentacion) {
            state.presentacion = presentacion
        },
        // Presentacion
        // TipoEmpaque
        setAllTipoEmpaque(state, allTipoEmpaque) {
            state.allTipoEmpaque = allTipoEmpaque
        },
        setTipoEmpaque(state, tipoEmpaque) {
            state.tipoEmpaque = tipoEmpaque
        },
        // TipoEmpaque
        // ItemPT
        setAllItemPT(state, allItemPT) {
            state.allItemPT = allItemPT
        },
        setItemPT(state, itemsPT) {
            state.itemsPT = itemsPT
        },
        // ItemPT
        // UnidadMedida
        setAllUnidadMedida(state, allUnidadMedida) {
            state.allUnidadMedida = allUnidadMedida;
        },
        setUnidadMedida(state, unidadMedida) {
            state.unidadMedida = unidadMedida;
        },
        // UnidadMedida
        // Conteo PT
        setAllConteoPT(state, allConteoPT) {
            state.allConteoPT = allConteoPT
        },
        // Conteo PT
    },
    actions: {
        fetchReporteRotacion({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/reporteRotacion', data)
                    .then(response => {
                        commit('setReporteRotacion', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchReporteConsumoHielo({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/reporte-consumohielo', {
                        params: data,
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchReporteBodegaTratado({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/reporte-tratado', {
                        params: data,
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchDatosExcel({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/datosExcel', data)
                    .then(response => {
                        commit('setDatosExcel', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchDivisiones({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/division')
                    .then(response => {
                        commit('setDivisiones', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchSubbodegas({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/produccion/subbodega/${data}`)
                    .then(response => {
                        commit('setSubbodegas', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchBodegasInternas({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/produccion/bodegaInterna/${data}`)
                    .then(response => {
                        commit('setBodegasInternas', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        guardarEtiqueta({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/guardar', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        guardarAgrupamiento({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/guardarAgrupamiento', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        guardarAgrupamientoBines({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/guardarAgrupamientoBines', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        guardarCoche({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/guardarCoche', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchEstablecimientoPantalla({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/establecimientoXpantalla', data)
                    .then(response => {
                        commit('setEstablecimientoPantalla', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },




        fetchFabricasPantalla({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/fabricasXpantalla', data)
                    .then(response => {
                        commit('setFabricasPantalla', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetchPermisosSolicitudCodigo({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/permisosSolicitudCodigo', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },


        fetchSolicitudxLote(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/fetchSolicitudxLote', data,{ responseType: 'arraybuffer' })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        registroSolicitudCodigos({ commit }, data) {
            console.log(data);
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/guardarSolicitudCodigos', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetch_obtenercoSolicitud({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/fetch_obtenercoSolicitud', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetch_ConsultaSolicitudCodigo({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/fetch_ConsultaSolicitudCodigo', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchSolicitudesCodigoPendientes({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/fetchSolicitudesCodigoPendientes', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchSolicitudesCodigo({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/fetchSolicitudesCodigo', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        actualizarEstadoSolicitudesCodigo({ commit }, data) {
            console.log(data);
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/updateSolicitudesCodigo', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },



        consultarCocheEtq({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/consultar-coche', {
                        params: data,
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        guardarProformaLiq({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/guardarProformaLiq', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        consultarProformaLiq({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/consultar-proformaLiq', {
                        params: data,
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },


        cambioEstado({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/cambioEstadoProforma', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        cambioEstadoCoche({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/cambioEstadoCoche', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },


        anularAgrupamientoBines({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/anularAgrupamientoBines', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchObtenerColores({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/obtenerColores')
                    .then(response => {
                        commit('setObtenerColores', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },


        fetchObtenerDatosTabla({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/obtenerDatosTabla')
                    .then(response => {
                        commit('setObtenerDatosTabla', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchMovimientos({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/produccion/informacion/${data}`)
                    .then(response => {
                        commit('setMovimientos', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchMovimientosAnular({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/informacionAnular', data)
                    .then(response => {
                        commit('setMovimientosAnular', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchEtiquetasAnuladas({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/infoEtiquetasAnuladas', data)
                    .then(response => {
                        commit('setEtiquetasAnuladas', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        anulacionEtiqueta({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/anular', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchLoteGraph({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/loteGraph', { params: data })
                    .then(response => {
                        commit('setLoteGraph', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchRangoFechas({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.post('/api/auth/produccion/rangoFechas', data).then(response => {
                    commit('setRangoFechas', response.data)
                    resolve(response)
                })
            })
        },

        fetchInfoLibras({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/infoLibras', data)
                    .then(response => {
                        commit('setInfoLibras', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        }, // cabinplant
        fetchInfoLibrasXProceso({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/infoLibrasXProceso', data)
                    .then(response => {
                        commit('setInfoLibrasXProceso', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchInfoLibrasXBodega({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/infoLibrasXBodega', data)
                    .then(response => {
                        commit('setInfoLibrasXBodega', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchEtiquetasXLote({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/reporteEtiquetasXLote', data)
                    .then(response => {
                        commit('setEtiquetasXLote', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchEtiquetasXArea({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/reporteEtiquetasXArea', data)
                    .then(response => {
                        commit('setEtiquetasXArea', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchColores({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/colores')
                    .then(response => {
                        commit('setColores', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchTipoLote({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/tipolote')
                    .then(response => {
                        commit('setTipoLote', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetchEstablecimientos({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/establecimientos')
                    .then(response => {
                        commit('setEstablecimientos', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchEstablecimientosOrigen({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/establecimientos')
                    .then(response => {
                        commit('setEstablecimientosOrigen', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchEstablecimientosDestino({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/establecimientoDestino')
                    .then(response => {
                        commit('setEstablecimientosDestino', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchEstablecimiento({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/establecimiento')
                    .then(response => {
                        commit('setEstablecimiento', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchFabricas({ commit }, data) {
            return new Promise((resolve, reject) => {
                const url = `/api/auth/produccion/fabrica?co_establecimiento=${data.cod}`
                axios
                    .get(url)
                    .then(response => {
                        if (data.mov == 'ogn') {
                            commit('setFabricas', response.data)
                        } else {
                            commit('setFabricasE', response.data)
                        }
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchProcesos({ commit }, data) {
            return new Promise((resolve, reject) => {
                const url = `/api/auth/produccion/proceso?co_fabrica=${data.cod}`
                axios
                    .get(url)
                    .then(response => {
                        if (data.mov == 'ogn') {
                            commit('setProcesos', response.data)
                        } else {
                            commit('setProcesosE', response.data)
                        }
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchAreas({ commit }, data) {
            return new Promise((resolve, reject) => {
                const url = `/api/auth/produccion/area?co_proceso=${data.cod}`
                axios
                    .get(url)
                    .then(response => {
                        if (data.mov == 'ogn') {
                            commit('setAreas', response.data)
                        } else {
                            commit('setAreasE', response.data)
                        }
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchEquipos({ commit }, data) {
            return new Promise((resolve, reject) => {
                const url = `/api/auth/produccion/equipo?co_area=${data.cod}`
                axios
                    .get(url)
                    .then(response => {
                        if (data.mov == 'ogn') {
                            commit('setEquipos', response.data)
                        } else {
                            commit('setEquiposE', response.data)
                        }
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchFabrica({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/produccion/fabricas/${data}`)
                    .then(response => {
                        commit('setFabrica', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchArea({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/produccion/areas/${data}`)
                    .then(response => {
                        commit('setArea', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchAreaSolicitudes({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/produccion/areasSolicitudes/${data}`)
                    .then(response => {
                        commit('setArea', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchAreaHielo({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/produccion/areas-hielo/${data}`)
                    .then(response => {
                        commit('setAreaHielo', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchAreaDescabezado({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/produccion/areaDescabezado/${data}`)
                    .then(response => {
                        commit('setAreaDescabezado', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchTallas({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/talla')
                    .then(response => {
                        commit('setTallas', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetchTipoEtiquetas({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/tipo_etiquetas')
                    .then(response => {
                        commit('setTipoEtiquetas', response.data)
                        resolve(response)
                        console.log(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetchLote({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/produccion/lote/${data}`)
                    .then(response => {
                        commit('setLote', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetchCamaronera({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/produccion/camaronera/${data}`)
                    .then(response => {
                        commit('setCamaronera', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetchControlProceso({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/controlproceso', data)
                    .then(response => {
                        // commit("setControlProceso", response.data);
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchControlProcesoDetalle({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/controlprocesodetalle', data)
                    .then(response => {
                        // commit("setControlProcesoDetalle", response.data);
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetchControlProcesoDetalleColor({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/controlprocesodetallecolor', data)
                    .then(response => {
                        // commit("setControlProcesoDetalle", response.data);
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetchControlLote({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/controllote', data)
                    .then(response => {
                        commit('setLote', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetchGetControlProceso({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/produccion/getcontrolproceso/${data}`)
                    .then(response => {
                        commit('setControlProceso', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetchExisteControlProceso({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/produccion/existecontrolproceso?nu_lote=${data}`)
                    .then(response => {
                        commit('setControlProceso', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        // tonny
        fetchDatosTablaExcel({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/datosCabiplant', data)
                    .then(response => {
                        // commit("setControlProceso", response.data);
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        registroControlProceso({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/registroProceso', data)
                    .then(response => {
                        // commit("setControlProceso", response.data);
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        anulacionProceso({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/anularproceso', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        pausarProceso({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/pausarproceso', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        cerrarProceso({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/cerrarproceso', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fechtSeguimientoOrigenProceso({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/seguimientorigenproceso', data)
                    .then(response => {
                        commit('setSeguimientoControlProceso', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchProcesolineacanasta({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/procesolineacanasta/', data)
                    .then(response => {
                        commit('setprocesolineacanasta', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fechtSeguimientoDestinoProceso({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/seguimientodestinoproceso', data)
                    .then(response => {
                        commit('setSeguimientoControlProceso', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fechtLineaNuCanastas({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/lineanucanastas', data)
                    .then(response => {
                        commit('setnucanastas', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetchInformacionLinea({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/produccion/informacionLinea/${data}`)
                    .then(response => {
                        commit('setinformacionLinea', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        // editar

        fetchlotecamaronera({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/produccion/lotecamaronera/${data}`)
                    .then(response => {
                        commit('setlotecamaronera', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetchEstablecimientoId({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/produccion/establecimientoid/${data}`)
                    .then(response => {
                        commit('setEstablecimiento', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetchProcesolinea({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/produccion/procesolinea/${data}`)
                    .then(response => {
                        commit('setprocesolinea', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchMovimientoBines({ commit }, data) {
            return new Promise((resolve, reject) => {
                if (data.descargar) {
                    axios({
                        method: 'get',
                        url: '/api/auth/produccion/reportemovimientoBines',
                        responseType: 'blob',
                        params: data,
                    })
                        .then(response => {
                            commit('setMovBines', response.data)
                            resolve(response)
                        })
                        .catch(error => {
                            reject(error)
                            console.error(error)
                        })
                } else {
                    axios
                        .get('/api/auth/produccion/reportemovimientoBines', {
                            params: data,
                        })
                        .then(response => {
                            commit('setMovBines', response.data)
                            resolve(response)
                        })
                        .catch(error => {
                            reject(error)
                            console.error(error)
                        })
                }
            })
        },

        fetchEditarProceso({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/editarproceso', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetchRendimiento({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/reporteRendimiento', data)
                    .then(response => {
                        commit('setRendimiento', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        changeDestino({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/cambiarDestino', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        liberarColores({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/liberarCanastas', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchDashboardClasificacion({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/dashboard-clasificacion')
                    .then(response => {
                        commit('setClasificacion', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchDashboardDescabezado({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/dashboard-descabezado')
                    .then(response => {
                        commit('setDescabezado', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchTapon({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/reporte-tapon', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchPlantasA20702({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/plantas')
                    .then(response => {
                        commit('setPlantasA20702', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchCodigosCalidad({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/codigoscalidad')
                    .then(response => {
                        commit('setCodigosCalidad', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchItemCamaronByCoMateria({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/produccion/itemCamaron/${data}`)
                    .then(response => {
                        commit('setItemCamaronByCoMateria', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchItemRecetaByCoItem({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/produccion/itemReceta/${data}`)
                    .then(response => {
                        commit('setItemRecetaByCoItem', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        consultarEtiqueta({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/consultar-etiqueta', {
                        params: data,
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        consultarEtiquetaReimprimirReembinada({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/consultar-etiqueta-reembinada', {
                        params: data,
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        guardarEtiquetaFraccion({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/guardar-etiqueta-fraccion', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        consultarReimprimir({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/consultar-etiqueta-reimprimir', {
                        params: data,
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        consultarEtiquetaUsadaGuia({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/consultar-etiqueta-usada-enguia', {
                        params: data,
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetchDescargarEspecificacionesDocx({ commit }, data) {
            return new Promise((resolve, reject) => {
                const link = '/api/auth/produccion/descargarEspecificacionesDocx'
                axios({
                    method: 'post',
                    url: link,
                    responseType: 'blob',
                    data,
                })
                    .then(response => {
                        commit('setDescargarEspecificacionesDocx', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchDescargarFichaTecnica({ commit }, data) {
            return new Promise((resolve, reject) => {
                const link = '/api/auth/produccion/descargar'
                axios({
                    method: 'post',
                    url: link,
                    responseType: 'blob',
                    data,
                })
                    .then(response => {
                        commit('setDescargarFichaTecnica', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        consultarReimprimirVARE({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/consultar-etiqueta-reimprimir-vare', {
                        params: data,
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        consultarReimprimirAgBines({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/consultar-etiqueta-reimprimir-AGBines', {
                        params: data,
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        guardarOrdenProduccion({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/saveOrden', data, {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                        },
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchOpcionesProduccionAbierta({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/opciones', {
                        params: data,
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        guardarOrdenProduccionAbierta({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/saveOrdenProduccionAbierta', data, {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                        },
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchNumOrden({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/numOrden')
                    .then(response => {
                        commit('setNumOrden', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        saveItemPanacea({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/saveItemPanacea', data, {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                        },
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchOrdenesProduccion({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/ordenesProduccion', {
                        params: data,
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        // Mantenimiento: getItemsCamaron
        fetchItemsCamaron({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/itemsCamaron', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchOpcionesItemCamaron({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/opcionesItemCamaron', {
                        params: data,
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchModificarGeneralesItemCamaron({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/modificarGeneralesItemCamaron', data)
                    .then(response => {
                        // commit('setVAGavetas', response.data);
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchGuardarGeneralesItemCamaron({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/guardarGeneralesItemCamaron', data)
                    .then(response => {
                        // commit('setVAGavetas', response.data);
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchGuardarRecetaItemCamaron({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/guardarRecetaItemCamaron', data)
                    .then(response => {
                        // commit('setVAGavetas', response.data);
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchGuardarFTItemCamaron({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/guardarFTItemCamaron', data, {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                        },
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchSecuenciaItemCamaron({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/produccion/secuencia/`)
                    .then(response => {
                        commit('setSecuenciaItemCamaron', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchItemCamaronProduccion({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/produccion/itemCamaronProduccion/${data}`)
                    .then(response => {
                        // commit('setItemCamaronByCoMateria', response.data);
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchActivoItemCamaron({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/activoItemCamaron', data)
                    .then(response => {
                        // commit('setActivoItemCamaron', response.data);
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchRecetaItemCamaron({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/recetaItemCamaron', {
                        params: data,
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchItemBodega({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/itemBodega', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        // Mantenimiento: getItemsCamaron
        fetchInfoOrden({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/produccion/getInfoOrden/${data}`)
                    .then(response => {
                        commit('setInfoOrden', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchFabricaxDivision({ commit }, data) {
            return new Promise((resolve, reject) => {
                const url = `/api/auth/produccion/fabricaxDivision/${data}`
                axios
                    .get(url)
                    .then(response => {
                        commit('setFabricasxDivision', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchVAGavetas({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/reporteVAGavetas', data)
                    .then(response => {
                        commit('setVAGavetas', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetchLibrasReclasificadas({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/reporteLibrasReclasificadas', data)
                    .then(response => {
                        commit('setLibrasClasificadas', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetchCocido({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/reporteCocido', data)
                    .then(response => {
                        commit('setLibrasCocido', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetchTratamiento({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/reporteTratamiento', data)
                    .then(response => {
                        // commit("setLibrasClasificadas", response.data);
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchPermisosOrdenPedidoDivision({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/permisos-orden-pedido-division', data)
                    .then(response => {
                        commit('setPermisosOrdenPedidoDivision', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchPermisosOrdenPedidoArea({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/permisos-orden-pedido-area', {
                        params: data,
                    })
                    .then(response => {
                        commit('setPermisosOrdenPedidoArea', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchOrdenPedido({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/orden-pedido', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchOrdenDetalle({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/orden-pedido-detalle', {
                        params: data,
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchOrdenes({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/getOrdenes', {
                        params: data,
                    })
                    .then(response => {
                        commit('setOrdenes', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchDescargarDocumentoOP({ commit }, data) {
            return new Promise((resolve, reject) => {
                const link = '/api/auth/produccion/descargarDocumentoOP'
                axios({
                    method: 'post',
                    url: link,
                    responseType: 'blob',
                    data,
                })
                    .then(response => {
                        commit('setDescargarDocumentoOP', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchLineasCamaron({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/getLineasCamaron', {
                        params: data,
                    })
                    .then(response => {
                        commit('setLineasCamaron', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetchAprobarOrden({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/aprobar-orden-pedido', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchDevolverOrden({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/devolver-orden-pedido', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetchControlBalanza({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/reporteControlBalanza', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetchLibrasLiqDecabezado({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/reporteLibrasLiqDecabezado', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetchListasDescabezado_rrhh({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/reporteListasDescabezado_rrhh', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetchControlBalanzaProfremar({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/reporteControlBalanzaProfremar', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        //console.error(error);
                    })
            })
        },

        fetchPermisosUsuarioReporte({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/reporteBalanzasP_T')
                    .then(response => {
                        commit('setTipoReporteP_T', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchPermisosPantallaPlanta({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/plantaXuserPantalla')
                    .then(response => {
                        commit('setPlantaxUserPantalla', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchDownloadFT({ commit }, data) {
            return new Promise((resolve, reject) => {
                const link = '/api/auth/produccion/downloadFT'
                axios({
                    method: 'post',
                    url: link,
                    responseType: 'blob',
                    data,
                })
                    .then(response => {
                        commit('setDownloadFT', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchA_I_FrescoyReproceso({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/reporte_A_I_FrescoyReproceso', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchValidarLoteVARE({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/produccion/validarLote/${data}`)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetch_ConsultaLoteExiste({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/consultarloteExiste', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetch_ConsultaLoteMascaraExiste({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/consultarloteMascaraChinoExiste', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetch_ConsultarItemCamaron({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/consultarItemCamaron', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchAgrupamientoVARE({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/produccion/agrupamientoVARE/${data}`)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchEtiquetasPendientes({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/produccion/agrupamientoBines`, {
                        params: {
                            co_establecimiento: data['co_establecimiento'],
                            co_fabrica: data['co_fabrica'],
                            co_area: data['co_area'],
                            co_proceso: data['co_proceso'],
                            reservado_guiavirtual: data['reservadas'],
                            co_guiavirtual: data['co_guiavirtual'],
                            inicio: data['inicio'],
                            fin: data['fin'],
                            tipo_lote: data['tipoLote_etqPadre'],
                        },
                    })
                    .then(response => {
                        //commit("setEtiquetasAGBin", response.data);
                        resolve(response)
                    })
                    .catch(error => {
                        console.log(error)
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetch_Cabecera208_liquidacion({ commit }, data) {
            console.log(data)
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/consultar_Cabecera208_liquidacion', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        consultarProformaEtqsLote({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/consultar-ProformaEtqsLote', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetch_ConsultaLoteMascara({ commit }, data) {
            console.log(data)
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/consultar_LoteMascara', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },


        fetch_ConsultaLoteChino({ commit }, data) {
            console.log(data);
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/consultar_LoteChino', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetchInfoItem({ commit }, data) {
            console.log(data)
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/consultar_InfoItem', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetchSaldoLoteMascara({ commit }, data) {
            console.log(data)
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/consultar_InfoSaldoLoteMascara', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetchSaldoLoteChino({ commit }, data) {
            console.log(data)
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/consultar_InfoSaldoLoteChino', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetchInfoItemChino({ commit }, data) {
            console.log(data);
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/consultar_InfoItemChino', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },


        fetchEquiposBinPP({ commit }, data) {
            return new Promise((resolve, reject) => {
                const url = `/api/auth/produccion/equipobinpp/${data}`
                axios
                    .get(url)
                    .then(response => {
                        commit('setMaquinas', response.data)
                        console.log(response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchEquiposTuneles({ commit }, data) {
            return new Promise((resolve, reject) => {
                const url = `/api/auth/produccion/equipostuneles/${data}`
                axios
                    .get(url)
                    .then(response => {
                        commit('setEquiposTuneles', response.data)
                        console.log(response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchDiferenciasPT({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/reporte_diferenciasPT', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchDiferenciasMP({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/reporte_diferenciasMP', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchRAgrupadosMP({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/reporte_diferenciasMP_RAG', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetchEstadoLoteF({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/reporteEstadoLotesF', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetchTiposLote({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/reporteTipoLotesF', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetchModiRendLoteF({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/reporte_Mod_rend_loteF', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetchIngreso_Camara({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/reporte_Ingreso_Camara', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetchIngManualActDestajos({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/reporte_Ingreso_ActDestajos', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetchAnulacion_I_VA({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/reporte_Anulacion_I_VA', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetchLibrasPendientes({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/reporteLibrasPendientes', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetchVAPendiente({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/resumenVAPendiente', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetchColaPendiente({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/resumenColaPendiente', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        // Liquidacion
        fetchTiposEmbarque({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/tiposEmbarque')
                    .then(response => {
                        commit('setTiposEmbarque', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchFacturaXEmbarqueTipo({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/facturaXEmbarqueTipo', {
                        params: data,
                    })
                    .then(response => {
                        commit('setFacturaXEmbarqueTipo', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchEmbarqueItems({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/embarqueItems', { params: data })
                    .then(response => {
                        commit('setEmbarqueItems', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchItemsXOrdProd({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/itemsXop', { params: data })
                    .then(response => {
                        commit('setItemsXOrdProd', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchGuardarLiqEmb({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/guardarLiqEmb', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchTiposProducto({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/tiposProducto')
                    .then(response => {
                        commit('setTiposProducto', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchTiposProductosByParams({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/mantenimiento/getTiposProductosByParams', {
                        params: data,
                    })
                    .then(response => {
                        commit('setTipoProducto', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        commit('setTipoProducto', [])
                        reject(error)
                    })
            })
        },
        fetchTiposCertificadosXProducto({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/tiposCertificadosXProducto', {
                        params: data,
                    })
                    .then(response => {
                        commit('setTiposCertificadosXProducto', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchLiqEmbarque({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/liqEmbarque', { params: data })
                    .then(response => {
                        commit('setLiqEmbarque', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchGuardarLiqExp({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/guardarLiqExp', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        actualizarSaldoProformaDetalle({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/actualizarSaldoProformaDetalle', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchHHEmbarque({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/HHEmbarque', { params: data })
                    .then(response => {
                        commit('setHHEmbarque', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchInfoEmbarque({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/infoEmbarque', { params: data })
                    .then(response => {
                        commit('setInfoEmbarque', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchValidarDetalleEmbarque({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/validarDetalleEmbarque', {
                        params: data,
                    })
                    .then(response => {
                        // commit("setInfoEmbarque", response.data);
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        agregarDetalleEmbarque({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/agregarDetalleEmbarque', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        // Liquidacion

        guardarEtiquetaReembinar({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/guardar-etiqueta-reembinar', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetchGuardarTransferencia({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/guardar-transferencia-materia-prima', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchTransferenciaMP({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/reporte-transferencia-materia-prima', {
                        params: data,
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchAreaMapeoVirtual({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/area-mapeo-virtual', {
                        params: data,
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetchTiempoEspera({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/reporteTiempoEspera', data)
                    .then(response => {
                        commit('setTiempoEspera', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetchGuardarMapeoVirtual({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/guardar-mapeo-virtual', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        async fetchEstablecimientosOrdenProduccion({ commit }, params) {
            return (
                await axios.get('/api/auth/produccion/list/establecimientos', {
                    params,
                })
            ).data
        },
        async fetchCorreos({ commit }, params) {
            return (await axios.get('/api/auth/produccion/correos', { params })).data
        },
        async downloadFichaTecnica(_, filename) {
            return await axios.get(`/api/auth/produccion/archivos/orden-produccion/${filename}`, { responseType: 'blob' })
        },
        fetchTiempoPlanta_Recepcion({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/reporteTiempoPlantaRecepcion', data)
                    .then(response => {
                        commit('setTiempoPlantaRecepcion', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchEtiquetasAgrupadasVA({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/etiquetasAgrupadasVA', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchAgrupamientoBines({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/reporteAgrupamientoBines', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetchContenedores({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/reporteContenedores', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetchProformas({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/reporteProformas', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },


        fetchAgrupamientoLotes({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/reporteAgrupamientoLotes', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        // TipoCongelacion
        fetchAllTipoCongelacion({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/mantenimiento/getAllTipoCongelacion', {
                        params: data,
                    })
                    .then(response => {
                        commit('setAllTipoCongelacion', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchTipoCongelacion({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/mantenimiento/getTipoCongelacion', {
                        params: data,
                    })
                    .then(response => {
                        commit('setTipoCongelacion', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchCreateTipoCongelacion({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/mantenimiento/createTipoCongelacion', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchUpdateTipoCongelacion({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/mantenimiento/updateTipoCongelacion', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchRemoveTipoCongelacion({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/mantenimiento/removeTipoCongelacion', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        // TipoCongelacion
        // Linea
        fetchAllLinea({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/mantenimiento/getAllLinea', {
                        params: data,
                    })
                    .then(response => {
                        commit('setAllLinea', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchLinea({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/mantenimiento/getLinea', {
                        params: data,
                    })
                    .then(response => {
                        commit('setLinea', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchCreateLinea({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/mantenimiento/createLinea', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchUpdateLinea({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/mantenimiento/updateLinea', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchRemoveLinea({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/mantenimiento/removeLinea', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        // Linea
        // Nandina
        fetchAllNandina({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/mantenimiento/getAllNandina', {
                        params: data,
                    })
                    .then(response => {
                        commit('setAllNandina', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchNandina({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/mantenimiento/getNandina', {
                        params: data,
                    })
                    .then(response => {
                        commit('setNandina', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchNandinaByParams({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/mantenimiento/getNandinasByParams', {
                        params: data,
                    })
                    .then(response => {
                        commit('setNandinaByParams', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchCreateNandina({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/mantenimiento/createNandina', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchUpdateNandina({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/mantenimiento/updateNandina', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchRemoveNandina({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/mantenimiento/removeNandina', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        // Nandina

        // Especie
        fetchAllEspecie({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/mantenimiento/getAllEspecie', {
                        params: data,
                    })
                    .then(response => {
                        commit('setAllEspecie', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchEspecie({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/mantenimiento/getEspecie', {
                        params: data,
                    })
                    .then(response => {
                        commit('setEspecie', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchEspeciesByParams({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/mantenimiento/getEspeciesByParams', {
                        params: data,
                    })
                    .then(response => {
                        commit('setEspecie', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        commit('setEspecie', [])
                        reject(error)
                    })
            })
        },
        fetchCreateEspecie({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/mantenimiento/createEspecie', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchUpdateEspecie({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/mantenimiento/updateEspecie', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchRemoveEspecie({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/mantenimiento/removeEspecie', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        // Especie
        // Marca
        fetchAllMarca({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/mantenimiento/getAllMarca', {
                        params: data,
                    })
                    .then(response => {
                        commit('setAllMarca', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchMarca({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/mantenimiento/getMarca', {
                        params: data,
                    })
                    .then(response => {
                        commit('setMarca', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchCreateMarca({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/mantenimiento/createMarca', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchUpdateMarca({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/mantenimiento/updateMarca', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchRemoveMarca({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/mantenimiento/removeMarca', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        // Marca
        // ProcesoVA
        fetchAllProcesoVA({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/mantenimiento/getAllProcesoVA', {
                        params: data,
                    })
                    .then(response => {
                        commit('setAllProcesoVA', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchProcesoVA({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/mantenimiento/getProcesoVA', {
                        params: data,
                    })
                    .then(response => {
                        commit('setProcesoVA', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchProcesosVAByParams({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/mantenimiento/getProcesosVAByParams', {
                        params: data,
                    })
                    .then(response => {
                        commit('setProcesoVA', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        commit('setProcesoVA', [])
                        reject(error)
                    })
            })
        },
        fetchCreateProcesoVA({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/mantenimiento/createProcesoVA', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchUpdateProcesoVA({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/mantenimiento/updateProcesoVA', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchRemoveProcesoVA({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/mantenimiento/removeProcesoVA', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        // ProcesoVA
        // Sublinea
        fetchAllSublinea({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/mantenimiento/getAllSublinea', {
                        params: data,
                    })
                    .then(response => {
                        commit('setAllSublinea', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchSublinea({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/mantenimiento/getSublinea', {
                        params: data,
                    })
                    .then(response => {
                        commit('setSublinea', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchSublineaXLinea({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/mantenimiento/getSublineaXLinea', {
                        params: data,
                    })
                    .then(response => {
                        commit('setSublineaXLinea', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        commit('setSublineaXLinea', [])
                        reject(error)
                    })
            })
        },
        fetchSublineasByParams({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/mantenimiento/getSublineasByParams', {
                        params: data,
                    })
                    .then(response => {
                        commit('setSublinea', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        commit('setSublinea', [])
                        reject(error)
                    })
            })
        },
        fetchCreateSublinea({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/mantenimiento/createSublinea', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchUpdateSublinea({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/mantenimiento/updateSublinea', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchRemoveSublinea({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/mantenimiento/removeSublinea', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        // Sublinea
        // Talla
        fetchAllTalla({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/mantenimiento/getAllTalla', {
                        params: data,
                    })
                    .then(response => {
                        commit('setAllTalla', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchTalla({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/mantenimiento/getTalla', {
                        params: data,
                    })
                    .then(response => {
                        commit('setTalla', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchCreateTalla({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/mantenimiento/createTalla', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchUpdateTalla({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/mantenimiento/updateTalla', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchRemoveTalla({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/mantenimiento/removeTalla', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        // Talla
        // TipoProducto
        fetchAllTipoProducto({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/mantenimiento/getAllTipoProducto', {
                        params: data,
                    })
                    .then(response => {
                        commit('setAllTipoProducto', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchTipoProducto({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/mantenimiento/getTipoProducto', {
                        params: data,
                    })
                    .then(response => {
                        commit('setTipoProducto', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchCreateTipoProducto({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/mantenimiento/createTipoProducto', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchUpdateTipoProducto({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/mantenimiento/updateTipoProducto', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchRemoveTipoProducto({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/mantenimiento/removeTipoProducto', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchTipoProductoByParams({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/mantenimiento/getTipoProductoByParams', {
                        params: data,
                    })
                    .then(response => {
                        commit('setTipoProductoByParams', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        // TipoProducto
        // Tratamiento
        fetchAllTratamiento({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/mantenimiento/getAllTratamiento', {
                        params: data,
                    })
                    .then(response => {
                        commit('setAllTratamiento', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchTratamiento({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/mantenimiento/getTratamiento', {
                        params: data,
                    })
                    .then(response => {
                        commit('setTratamiento', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchCreateTratamiento({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/mantenimiento/createTratamiento', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchUpdateTratamiento({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/mantenimiento/updateTratamiento', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchRemoveTratamiento({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/mantenimiento/removeTratamiento', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        // Tratamiento
        // Unidad
        fetchAllUnidad({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/mantenimiento/getAllUnidad', {
                        params: data,
                    })
                    .then(response => {
                        commit('setAllUnidad', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchUnidad({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/mantenimiento/getUnidad', {
                        params: data,
                    })
                    .then(response => {
                        commit('setUnidad', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchCreateUnidad({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/mantenimiento/createUnidad', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchUpdateUnidad({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/mantenimiento/updateUnidad', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchRemoveUnidad({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/mantenimiento/removeUnidad', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        // Unidad
        // Certificacion
        fetchAllCertificacion({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/mantenimiento/getAllCertificacion', {
                        params: data,
                    })
                    .then(response => {
                        commit('setAllCertificacion', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchCertificacion({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/mantenimiento/getCertificacion', {
                        params: data,
                    })
                    .then(response => {
                        commit('setCertificacion', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchCreateCertificacion({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/mantenimiento/createCertificacion', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchUpdateCertificacion({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/mantenimiento/updateCertificacion', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchRemoveCertificacion({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/mantenimiento/removeCertificacion', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        //Registro de operatividad
        fetchProcesosOperatividad({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get(
                        `/api/auth/produccion/getProcesosOperatividad?co_fabrica=${data.co_fabrica}&turno=${data.turno}&fecha_turno=${data.fecha_turno}`
                    )
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchRegistrarOperatividad({ commit }, data) {
            //  console.log(data)
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/registrarOperatividad', {
                        params: data,
                    })
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchModificarRegistroOperatividad({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/modificarOperatividad', {
                        params: data,
                    })
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchHistorialOperatividad({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/historialOperatividad', {
                        params: data,
                    })
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchRegistroInfoMascara({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/registroInfoMascara', {
                        params: data,
                    })
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchOperatividadCreados({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/getRegistrosOperatividad', {
                        params: data,
                    })
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchModificarMascara({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/modificarMascara', {
                        params: data,
                    })
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchRegistroTipoProducto({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/registrarTipoProducto', {
                        params: data,
                    })
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchTipoProductosCreados({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/getTipoProducto', {
                        params: data,
                    })
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchModificarTipoProducto({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/modificarTipoProducto', {
                        params: data,
                    })
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchProcesosMaquinasEquipos({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/getProcesosMaquinasEquipos', {
                        params: data,
                    })
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchConfiguracionOperatividad({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/configuracionOperatividad', {
                        params: data,
                    })
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        // Certificacion
        // Calidad
        fetchAllCalidad({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/mantenimiento/getAllCalidad', {
                        params: data,
                    })
                    .then(response => {
                        commit('setAllCalidad', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchCalidad({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/mantenimiento/getCalidad', {
                        params: data,
                    })
                    .then(response => {
                        commit('setCalidad', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchCreateCalidad({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/mantenimiento/createCalidad', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchUpdateCalidad({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/mantenimiento/updateCalidad', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchRemoveCalidad({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/mantenimiento/removeCalidad', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        // Calidad
        // EstadoProducto
        fetchAllEstadoProducto({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/mantenimiento/getAllEstadoProducto', {
                        params: data,
                    })
                    .then(response => {
                        commit('setAllEstadoProducto', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchEstadoProducto({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/mantenimiento/getEstadoProducto', {
                        params: data,
                    })
                    .then(response => {
                        commit('setEstadoProducto', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchCreateEstadoProducto({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/mantenimiento/createEstadoProducto', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchUpdateEstadoProducto({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/mantenimiento/updateEstadoProducto', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchRemoveEstadoProducto({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/mantenimiento/removeEstadoProducto', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        // EstadoProducto

        // MateriaPrima
        fetchAllMateriaPrima({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/mantenimiento/getAllMateriaPrima', {
                        params: data,
                    })
                    .then(response => {
                        commit('setAllMateriaPrima', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchMateriaPrima({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/mantenimiento/getMateriaPrima', {
                        params: data,
                    })
                    .then(response => {
                        commit('setMateriaPrima', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchCreateMateriaPrima({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/mantenimiento/createMateriaPrima', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchUpdateMateriaPrima({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/mantenimiento/updateMateriaPrima', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchRemoveMateriaPrima({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/mantenimiento/removeMateriaPrima', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        // MateriaPrima
        // Presentacion
        fetchAllPresentacion({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/mantenimiento/getAllPresentacion', {
                        params: data,
                    })
                    .then(response => {
                        commit('setAllPresentacion', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchPresentacion({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/mantenimiento/getPresentacion', {
                        params: data,
                    })
                    .then(response => {
                        commit('setPresentacion', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchCreatePresentacion({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/mantenimiento/createPresentacion', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchUpdatePresentacion({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/mantenimiento/updatePresentacion', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchRemovePresentacion({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/mantenimiento/removePresentacion', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        // Presentacion
        // TipoEmpaque
        fetchAllTipoEmpaque({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/mantenimiento/getAllTipoEmpaque', {
                        params: data,
                    })
                    .then(response => {
                        commit('setAllTipoEmpaque', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchTipoEmpaque({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/mantenimiento/getTipoEmpaque', {
                        params: data,
                    })
                    .then(response => {
                        commit('setTipoEmpaque', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchCreateTipoEmpaque({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/mantenimiento/createTipoEmpaque', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchUpdateTipoEmpaque({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/mantenimiento/updateTipoEmpaque', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchRemoveTipoEmpaque({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/mantenimiento/removeTipoEmpaque', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        // TipoEmpaque
        // ItemPT
        fetchAllItemPT({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/mantenimiento/getAllItemPT', {
                        params: data,
                    })
                    .then(response => {
                        commit('setAllItemPT', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchItemPT({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/mantenimiento/getItemPT', {
                        params: data,
                    })
                    .then(response => {
                        commit('setItemPT', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchCreateItemPT({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/mantenimiento/createItemPT', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchUpdateItemPT({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/mantenimiento/updateItemPT', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchRemoveItemPT({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/mantenimiento/removeItemPT', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchPararRegOp({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/pararOperatividad', {
                        params: data,
                    })
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchRegistroOperatividad({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/reporteRegistroOperatividad', {
                        params: data,
                    })
                    .then(response => {
                        //   commit('setItemPT', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchStockXPlanta({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/stockXPlanta', {
                        params: data,
                    })
                    .then(response => {
                        commit('setCategoria', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        // ItemPT
        // UnidadMedida
        fetchAllUnidadMedida({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/api/auth/produccion/mantenimiento/getAllUnidadMedida", {
                        params: data,
                    })
                    .then((response) => {
                        commit("setAllUnidadMedida", response.data);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        fetchUnidadMedida({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/api/auth/produccion/mantenimiento/getUnidadMedida", {
                        params: data,
                    })
                    .then((response) => {
                        commit("setUnidadMedida", response.data);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        fetchUnidadMedidaByParams({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/mantenimiento/getUnidadMedidaByParams', {
                        params: data,
                    })
                    .then((response) => {
                        commit('setUnidadMedida', response.data)
                        resolve(response)
                    })
                    .catch((error) => {
                        commit('setUnidadMedida', [])
                        reject(error)
                    })
            })
        },
        fetchCreateUnidadMedida({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post(
                        "/api/auth/produccion/mantenimiento/createUnidadMedida",
                        data
                    )
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        fetchUpdateUnidadMedida({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post(
                        "/api/auth/produccion/mantenimiento/updateUnidadMedida",
                        data
                    )
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        fetchRemoveUnidadMedida({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post(
                        "/api/auth/produccion/mantenimiento/removeUnidadMedida",
                        data
                    )
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        // UnidadMedida
        // Conteo PT
        fetchAllConteoPT({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/getConteoPT', {
                        params: data,
                    })
                    .then(response => {
                        commit('setAllConteoPT', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchEquiposPT({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/getEquiposPT', {
                        params: data,
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchProcesoLote({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/getProcesoLote', {
                        params: data,
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchLoteChino({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/getLoteChino', {
                        params: data,
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchEliminarConteoPT({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/eliminarConteoPT', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchGuardarConteoPT({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/guardarConteoPT', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchConteoPTEstado({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/cambiarEstadoLoteChino', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        // Conteo PT
        fetchIndicadores({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/fetchIndicadores', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchReporteIndicadores({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/fetchReporteIndicadores', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        deleteExisteIndicadores({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/deleteExisteIndicadores', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        postIndicadorA({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/postIndicadorA', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        // Registro de horas máquina
        fetchEstablecimientosRHM() {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/establecimientosRHM')
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchFabricasRHM(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/fabricasRHM', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchEquiposRHM(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/equiposRHM', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchHorasMaquina(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/horasMaquina', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        postGuardarHoras(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/produccion/guardarHoras', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        deleteEliminarHoras(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .delete('/api/auth/produccion/eliminarHoras', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchInformeHorasMaquina(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/informeHorasMaquina', { params: data })
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        // Registro de horas máquina

        // Informe pesos rechazo
        fetchInformePesosRechazo(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/informePesosRechazo', { params: data })
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        // Informe pesos rechazo

        // Libras procesadas
        fetchTodoEstablecimientos() {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/todoEstablecimientos')
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchAreasPorFabrica(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/areasPorFabrica', { params: data })
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchLibrasProcesadas(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/librasProcesadas', { params: data })
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchTiposProductoPorArea(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/tiposProductoPorArea', { params: data })
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchLotesParaLibras(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccion/lotesParaLibras', { params: data })
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        // Libras procesadas
    },
}
